import {  NotaFiscalServiceAdapter, ParamsFindNotaFiscal } from '@/usecases'
import { find } from '@/api/notasFiscais'
export class NotaFiscalService implements NotaFiscalServiceAdapter {
	find = async (params?: ParamsFindNotaFiscal) => await find(params);
}
